// export const formatNumberWithCommas = (number) => {
//     return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
// };

// export const formatNumberWithCommas = (number) => {
//     return new Intl.NumberFormat().format(Number(number));
// };

export const formatNumberWithCommas = (number) => {
    return Number(number).toLocaleString();
};